import { openSnackbar } from 'store/slices/snackbar';
import { getIntl } from 'shared/utils/localesHelper';
import { BaseQueryApi } from '@reduxjs/toolkit/query';


type SnackbarOptions<TArg = any> = {
    successMessage?: string;
    errorMessage?: string;
   onSuccess?: (args: {
    arg: TArg;
    result: any;
    dispatch: BaseQueryApi['dispatch'];
  }) => void;

   onError?: (args: {
    arg: TArg;
    error: any;
    dispatch: BaseQueryApi['dispatch'];
  }) => void;

};

export function snackbarOnQueryStarted<TArg = any>({
    successMessage,
    errorMessage,
    onSuccess,
    onError,
}: SnackbarOptions<TArg>) {
  return async (arg: TArg, api: any) => {
    const { dispatch, queryFulfilled } = api;
    const intl = await getIntl();
    try {
      const result = await queryFulfilled;

      if (successMessage) {
        dispatch(
          openSnackbar({
            open: true,
            message: intl.formatMessage({ id: successMessage }),
            variant: "alert",
            anchorOrigin: { vertical: "top", horizontal: "right" },
            transition: "SlideLeft",
            autoHideDuration: 6000,
            alert: {
                color: "success",
            },
            close: false,
          })
        );
      }

      onSuccess?.({ arg, result, dispatch });
    } catch (error) {
      if (errorMessage) {
        dispatch(
            openSnackbar({
                open: true,
                message: intl.formatMessage({ id: errorMessage }),
                variant: "alert",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                transition: "SlideLeft",
                autoHideDuration: 6000,
                alert: {
                    color: "error",
                },
                close: false,
          })
        );
      }

      onError?.({ arg, error, dispatch });
    }
  };
}

